module.exports = __webpack_public_path__ + "static/media/RR-2.c75f6549.png";